import { createStore } from 'vuex';
import VueCookies from 'vue-cookies';
import UserAccountStore from '@/store/modules/UserAccountStore';
import PaymentStore from '@/store/modules/PaymentStore';
import UserStore from '@/store/modules/UserStore';
import FileStore from '@/store/modules/FileStore';

export default new createStore({
    state: {
        user:{
            loggedIn: false,
            data: null
        }
    },
    mutations: {
        setLoggedIn(state, value){
            state.user.loggedIn = value;
        },
        setUser(state, data){
            state.user.data = data;
            VueCookies.set('koreaderma_accessToken', data.accessToken);
            VueCookies.set('koreaderma_refreshToken', data.refreshToken);
            VueCookies.set('koreaderma_email', data.email);
            VueCookies.set('koreaderma_useruid', data.useruid);
            VueCookies.set('koreaderma_profileComplete', data.profileComplete);
        },
        logoutUser(state){
            state.user.loggedIn = false;
            state.user.data = null;
            VueCookies.remove('koreaderma_accessToken');
            VueCookies.remove('koreaderma_refreshToken');
            VueCookies.remove('koreaderma_email');
            VueCookies.remove('koreaderma_useruid');
            VueCookies.remove('koreaderma_profileComplete');
        },
        updateProfileComplete(state, value){
            state.user.data.profileComplete = value;
            VueCookies.set('koreaderma_profileComplete', value);
        },
    },
    getters: {
        user(state){
            return state.user
        }
    },
    actions: {},
    modules: {
        UserAccountStore: UserAccountStore,
        PaymentStore: PaymentStore,
        UserStore: UserStore,
        FileStore: FileStore,
    },
});
